/**
 * Implements a chart picker
 * Contains a list of chart modes
 */
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ReactTooltip from 'react-tooltip';
import { actionUpdateChartPicker } from '../../actions/chart_picker';
import { IStore } from '../../reducers';
import { IChartPickerSelection } from '../../reducers/chart_picker';
import GridPicker from '../Chart/GridPicker';
import Widgets from '../Widgets';
import Text from '../../atoms/Text';

import './styles.scss';

const ChartPicker = () => {
  const [opened, setOpened] = useState(false);
  const dispatch = useDispatch();
  const selected = useSelector((state: IStore) => state.chart_picker.selected);

  const onSelect = (mode: IChartPickerSelection) => {
    dispatch(actionUpdateChartPicker(mode));
    setOpened(false);
  };

  return (
    <>
      <div
        className={`picker header__cnt icon-view-table ${
          opened ? 'picker--active' : ''
        }`}
        data-for='picker-tooltip'
        data-effect='solid'
        data-place='right'
        data-tip='Click to select chart layout'
        onClick={() => setOpened(!opened)}
      />
      {opened && (
        <div className='picker__content'>
          <Widgets />
          <Text size={14} className='text--grey-200 text--weight-600'>
            Charts view
          </Text>
          <GridPicker selected={selected} onSelect={onSelect} />
        </div>
      )}
      <ReactTooltip id='picker-tooltip' />
      {opened && (
        <div className='picker__backdrop' onClick={() => setOpened(false)} />
      )}
    </>
  );
};

export default ChartPicker;
